import { State } from '../../reducers/rootReducer'
import CarlineGroup from '../../../entities/CarlineGroup'

const carlineGroupsSelector = (state: State): CarlineGroup[] => state.carlineData.carlineGroups

export default carlineGroupsSelector
